const n = ["file", "folder"], o = ["lazy", "eager"], r = [
  "contain",
  "cover",
  "fill",
  "none",
  "scale-down"
], e = ["sync", "async", "auto"], i = ["anonymous", "use-credentials"], s = [
  "no-referrer",
  "no-referrer-when-downgrade",
  "origin",
  "origin-when-cross-origin",
  "same-origin",
  "strict-origin",
  "strict-origin-when-cross-origin",
  "unsafe-url"
];
export {
  n as ASSET_VARIANTS,
  i as CROSSORIGIN_VALUES,
  e as DECODING_TYPES,
  o as LOADING_TYPES,
  r as OBJECT_FIT_VALUES,
  s as REFERRERPOLICY_VALUES
};
//# sourceMappingURL=Asset.types.js.map
